module.exports = __webpack_public_path__ + "img/frontal-white.2f2fa098.svg";